import {
  createRouter,
  createWebHistory,
  isNavigationFailure,
} from "vue-router";

/**
 * Pack level 0 -> solo mail
 * Pack level 10 -> crm completo
 */

// PAGINE -------------------------------------------------------

// const TheLandingPage = () => import("./components/TheLandingPage.vue");
const TheMissing404 = () => import("./components/TheMissing404.vue");

// CONTATTI -----------------------------------------------------

const ContactTable = () =>
  import("./components/features/contact/table/ContactTable.vue");
const ContactWindow = () =>
  import("./components/features/contact/AddContact.vue");
const UserWindow = () =>
  import("./components/UI/settingsOptions/UserWindow.vue");
const CampingWindow = () =>
  import("./components/UI/settingsOptions/CampingWindow.vue");
const TracciaMail = () =>
  import("./components/features/contact/TracciaMail.vue");

// PREVENTIVI ---------------------------------------------------

const ContactForm = () => import("./components/features/form/ContactForm.vue");
const ContactFormL = () => import("./components/features/form/ContactFormL.vue");
const UnsubscribeNewsletters = () =>
  import("./components/features/mail/unsubscribeNewsletters.vue");
const QuoteRequest = () =>
  import("./components/features/quote/requests/QuoteRequest.vue");
const QuoteRequestRefuse = () =>
  import("./components/features/quote/requests/QuoteRequestRefuse.vue");

// PREVENTIVI ---------------------------------------------------

const QuoteTable = () =>
  import("./components/features/quoteDashboard/table/QuoteTable.vue");
const QuoteWindow = () =>
  import("./components/features/quoteDashboard/QuoteWindow.vue");
const QuoteRequestWindow = () =>
  import("./components/features/quote/requests/QuoteRequestWindow.vue");
const QuoteWindowDetail = () =>
  import("./components/features/quoteDashboard/QuoteWindowDetail.vue");
const QuoteEdit = () =>
  import("./components/features/quoteDashboard/QuoteEdit.vue");
const QuoteModalWindow = () =>
  import("./components/features/quote/components/QuoteModalWindow.vue");
const QuoteStep1Creation = () =>
  import("./components/features/quote/steps/QuoteStep1Creation.vue");
const QuoteStep2Preview = () =>
  import("./components/features/quote/steps/QuoteStep2Preview.vue");
const MiniSito = () =>
  import("./components/features/quoteDashboard/MiniSito.vue");
const MiniSitoL = () =>
  import("./components/features/quoteDashboard/MiniSitoL.vue");
const MiniSitoScheda = () =>
  import("./components/features/quoteDashboard/MiniSitoScheda.vue");
const MiniSitoSchedaL = () =>
  import("./components/features/quoteDashboard/MiniSitoSchedaL.vue");

// CV SYNCH PRENOTAZIONE ---------------------------------------------------

const StepsPrenotazione = () =>
  import("./components/features/quoteDashboard/CvPrenotazione/MainStep.vue");
const DisponibilitaStep = () =>
  import(
    "./components/features/quoteDashboard/CvPrenotazione/DisponibilitaStep.vue"
  );
const DisponibilitaStepL = () =>
  import(
    "./components/features/quoteDashboard/CvPrenotazione/DisponibilitaStepL.vue"
  );
const RisorsaStep = () =>
  import("./components/features/quoteDashboard/CvPrenotazione/RisorsaStep.vue");
const ConfermaPrenotazioneStep = () =>
  import(
    "./components/features/quoteDashboard/CvPrenotazione/ConfermaPrenotazioneStep.vue"
  );
const ConfermaPrenotazioneStepL = () =>
  import(
    "./components/features/quoteDashboard/CvPrenotazione/ConfermaPrenotazioneStepL.vue"
  );

// MAILING LIST -------------------------------------------------

const MailingList = () =>
  import("./components/features/mailingList/MailingList.vue");
const ListEdit = () => import("./components/features/mailingList/ListEdit.vue");
const SendNewsletter = () =>
  import("./components/features/mailingList/SendNewsletter.vue");
const Templator = () =>
  import("./components/features/mailingList/TemplateEditor.vue");
const MailingDetails = () =>
  import("./components/features/mailingList/MailingListsDetails.vue");
const MailingUnsubscribe = () =>
  import("./components/features/mailingList/MailingUnsubscribe.vue");
const TemplateDash = () =>
  import("./components/features/mailingList/TemplateDashboard.vue");
const StepsMailing = () =>
  import("./components/features/mailingList/StepMailing.vue");
const ListStep = () =>
  import("./components/features/mailingList/steps/ListsStep.vue");
const TemplateStep = () =>
  import("./components/features/mailingList/steps/TemplateStep.vue");
const ResumeStep = () =>
  import("./components/features/mailingList/steps/ResumeStep.vue");

// ALTRO --------------------------------------------------------

const ClientMail = () => import("./components/features/mail/ClientMail.vue");
const TheLogin = () => import("./components/TheLogin.vue");
const LoginCV = () => import("./components/UI/LoginCV.vue");
const LoginCVL = () => import("./components/UI/LoginCVL.vue");
const EmailCV = () => import("./components/features/emailCV/EmailCV.vue");
const EmailCVL = () => import("./components/features/emailCV/EmailCVL.vue");
const ClientMailCV = () =>
  import("./components/features/mail/ClientMailCloudvillage.vue");
const ImageManager = () =>
  import("./components/features/gestoreImmagini/ImageManager.vue");
const SettingsMailCV = () =>
  import("./components/UI/settingsOptions/TheMailCV.vue");
const SettingsMailCVL = () =>
  import("./components/UI/settingsOptions/TheMailCVL.vue");
const TheSettings = () => import("./components/UI/TheSettings.vue");
const TheSettingsL = () => import("./components/UI/TheSettingsL.vue");
const TheDashboard = () =>
  import("./components/features/dashboard/TheDashboard.vue");
const Loader = () => import("./components/UI/TheLoadingSpinner.vue");
const GmailBinder = () =>
  import("./components/UI/settingsOptions/GmailBinder.vue");

import store from "./store/index.js";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: "home",
      path: "/",
      component: TheDashboard,
      alias: ["/home"],
      meta: {
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "clienti",
      path: "/clienti/:newClient?",
      component: ContactTable,
      meta: {
        title: "Contatti",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "clienti-info",
          path: ":clienteID",
          component: ContactWindow,
        },
      ],
    },
    {
      name: "settings",
      path: "/settings",
      component: TheSettings,
      meta: {
        title: "Settings",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "settingsl",
      path: "/settingsL",
      component: TheSettingsL,
      meta: {
        title: "Settings",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "settingsUsers",
      path: "/settings?v=showUsers",
      component: TheSettings,
      meta: {
        title: "Settings",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "utenti-info",
          path: ":utenteID",
          component: UserWindow,
        },
      ],
    },
    {
      name: "settingsUsersL",
      path: "/settingsL?v=showUsers",
      component: TheSettings,
      meta: {
        title: "Settings",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "utenti-infoL",
          path: ":utenteID",
          component: UserWindow,
        },
      ],
    },
    {
      name: "settingsCamps",
      path: "/settings?v=showCamp",
      component: TheSettings,
      meta: {
        title: "Settings",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "campeggi-info",
          path: ":campingID",
          component: CampingWindow,
        },
      ],
    },
    {
      name: "settingsCampsL",
      path: "/settingsL?v=showCamp",
      component: TheSettings,
      meta: {
        title: "Settings",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "campeggi-infoL",
          path: ":campingID",
          component: CampingWindow,
        },
      ],
    },
    {
      name: "manageGmail",
      path: "/manageGmail",
      component: GmailBinder,
      meta: {
        title: "Gmail Binder",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "form-contatti-flag",
      path: "/contattaci/:idCampeggio/:idLingua/:noFlag?",
      component: ContactForm,
      meta: {
        requiresAuth: false,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "form-contatti-flagl",
      path: "/contattaciL/:idCampeggio/:idLingua/:noFlag?",
      component: ContactFormL,
      meta: {
        requiresAuth: false,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "form-contatti-lingua",
      path: "/contattaci/:idCampeggio/:idLingua?",
      component: ContactForm,
      meta: {
        requiresAuth: false,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "form-contatti-lingual",
      path: "/contattaciL/:idCampeggio/:idLingua?",
      component: ContactFormL,
      meta: {
        requiresAuth: false,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "form-contatti-empty",
      path: "/contattaci/:idCampeggio?",
      component: ContactForm,
      meta: {
        requiresAuth: false,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "form-contatti-emptyl",
      path: "/contattaciL/:idCampeggio?",
      component: ContactFormL,
      meta: {
        requiresAuth: false,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "unsub-newsletters",
      path: "/unsubscribe/:idCampeggio/:idCliente",
      component: UnsubscribeNewsletters,
      meta: {
        requiresAuth: false,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "mini-sito",
      path: "/visualizzaPreventivo/:clienteID/:idPreventivo/:idCampeggio",
      component: MiniSito,
      meta: {
        title: "Mini sito",
        requiresAuth: false,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "mini-sito-dettaglio",
          path: ":schedaID",
          component: MiniSitoScheda,
          meta: {
            title: "Mini sito card",
            requiresAuth: false,
            packLevel: 10,
            visualLevel: 1,
          },
        },
      ],
    },
    {
      name: "mini-sitol",
      path: "/visualizzaPreventivoL/:clienteID/:idPreventivo/:idCampeggio",
      component: MiniSitoL,
      meta: {
        title: "Mini sito",
        requiresAuth: false,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "mini-sito-dettagliol",
          path: ":schedaID",
          component: MiniSitoSchedaL,
          meta: {
            title: "Mini sito card",
            requiresAuth: false,
            packLevel: 10,
            visualLevel: 1,
          },
        },
      ],
    },

    {
      name: "mail",
      path: "/mail",
      component: ClientMail,
      meta: {
        requiresAuth: true,
        title: "E-Mail",
        packLevel: 0,
        visualLevel: 1,
      },
    },
    {
      name: "tracciaMail",
      path: "/tracciaMail/:thread",
      component: TracciaMail,
      meta: {
        requiresAuth: true,
        title: "Traccia Mail",
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "richiedi-preventivo",
      path: "/crea-preventivo/:idPreventivo?/:idCliente?",
      component: QuoteStep1Creation,
      meta: {
        title: "Crea Preventivo",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "clienti-preventivo",
          path: "edit/:clienteID",
          component: ContactWindow,
        },
      ],
    },
    {
      name: "richiedi-preventivo-step-1",
      path: "/crea-preventivo/:idCliente?/:idPreventivo?",
      component: QuoteStep1Creation,
      meta: {
        title: "Crea Preventivo",
      },
      props: true,
    },
    {
      name: "richiedi-preventivo-step-2",
      path: "/crea-preventivo/preview/:idCliente?/:idPreventivo?/:mailPreview?",
      component: QuoteStep2Preview,
      meta: {
        title: "Anteprima Preventivo",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      props: true,
    },
    {
      name: "preview-scheda",
      path: "/crea-preventivo/preview/:idCliente/:idPreventivo/scheda/:schedaID",
      component: QuoteModalWindow,
      meta: {
        title: "Scheda Preventivo",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      props: true,
    },
    // {
    //   name: "preview-mail",
    //   path: "/crea-preventivo/preview/:idCliente/:idPreventivo/mailPreview",
    //   component: QuoteStep2Preview,
    //   meta: {
    //     title: "Anteprima Mail",
    //     requiresAuth: true,
    //     packLevel: 10,
    //     visualLevel: 1,
    //   },
    //   props: true,
    // },
    {
      name: "preventivi",
      path: "/preventivi",
      component: QuoteTable,
      meta: {
        title: "Preventivi",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "preventivo-prew",
          path: ":idPreventivo/:idCliente?",
          component: QuoteWindow,
          meta: {
            title: "Preventivi",
            requiresAuth: true,
            packLevel: 10,
            visualLevel: 1,
          },
          children: [
            {
              name: "preventivo-dettaglio",
              path: ":schedaID",
              component: QuoteWindowDetail,
              meta: {
                title: "Preventivi",
                requiresAuth: true,
                packLevel: 10,
                visualLevel: 1,
              },
            },
            {
              name: "steps-prenotazione",
              path: "stepsPrenotazione",
              component: StepsPrenotazione,
              meta: {
                title: "Steps Prenotazione",
                requiresAuth: true,
                packLevel: 10,
                visualLevel: 1,
              },
              children: [
                {
                  name: "steps-quote-disp",
                  path: "disponibilita",
                  component: DisponibilitaStep,
                },
                {
                  name: "steps-quote-displ",
                  path: "disponibilital",
                  component: DisponibilitaStepL,
                },
                {
                  name: "steps-quote-ris",
                  path: "risorsa",
                  component: RisorsaStep,
                },
                {
                  name: "steps-quote-resume",
                  path: "conferma",
                  component: ConfermaPrenotazioneStep,
                },
                {
                  name: "steps-quote-resumel",
                  path: "conferma",
                  component: ConfermaPrenotazioneStepL,
                },
              ],
            },
          ],
          props: true,
        },
      ],
    },
    {
      name: "rifiuta-preventivo",
      path: "/richieste/refuse/:idPreventivo",
      component: QuoteRequestRefuse,
      meta: {
        title: "Rifiuta Preventivo",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      props: true,
    },
    {
      name: "richieste",
      path: "/richieste",
      component: QuoteRequest,
      meta: {
        title: "Richieste preventivo",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "richiesta-preventivo-preview",
          path: "preview/:idPreventivo",
          component: QuoteRequestWindow,
          meta: {
            title: "Req",
            requiresAuth: true,
            packLevel: 10,
            visualLevel: 1,
          },
        },
        {
          name: "richiesta-preventivo-preview-cliente",
          path: "preview/:idPreventivo/:clienteID",
          component: ContactWindow,
          meta: {
            title: "ReqCli",
            requiresAuth: true,
            packLevel: 10,
            visualLevel: 1,
          },
          props: true,
        },
        {
          name: "richiesta-preventivo-select-cliente",
          path: "preview/:idPreventivo/:clienteID",
          component: ContactWindow,
          meta: {
            title: "ReqCli",
            requiresAuth: true,
            packLevel: 10,
            visualLevel: 1,
          },
          props: true,
        },
      ],
    },
    {
      name: "edit-preventivi",
      path: "/preventivo/edit/:preventivoID",
      component: QuoteEdit,
      meta: {
        title: "Dati Preventivo",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      props: true,
    },
    {
      name: "mailing-list",
      path: "/mailing",
      component: MailingList,
      meta: {
        title: "Liste di destinazione",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      children: [
        {
          name: "lists-info",
          path: ":listId",
          component: MailingDetails,
        },
        {
          name: "steps-mailing",
          path: "/stepsMailing",
          component: StepsMailing,
          meta: {
            title: "Steps Mailing",
            requiresAuth: true,
            packLevel: 10,
            visualLevel: 1,
          },
          children: [
            {
              name: "steps-list-dash",
              path: "lista",
              component: ListStep,
            },
            {
              name: "steps-temp-dash",
              path: "template",
              component: TemplateStep,
            },
            {
              name: "steps-resume-dash",
              path: "resume",
              component: ResumeStep,
            },
          ],
        },
      ],
    },
    {
      name: "unsubscribe-list",
      path: "/mailing/unsubscribe/:campId/:userId/:lang?",
      component: MailingUnsubscribe,
      meta: {
        title: "Disiscriviti Lista",
        requiresAuth: false,
        packLevel: 0,
        visualLevel: 0,
      },
      props: true,
    },
    {
      name: "edit-list",
      path: "/mailing/edit/:id",
      component: ListEdit,
      meta: {
        title: "Info Lista",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      props: true,
    },
    {
      name: "send-newsletter",
      path: "/mailing/newsletter/:id",
      component: SendNewsletter,
      meta: {
        title: "Newsletter",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
      props: true,
    },
    {
      name: "login",
      path: "/login",
      component: TheLogin,
      meta: {
        title: "Login",
        requiresAuth: false,
        packLevel: 0,
        visualLevel: 0,
      },
    },
    {
      name: "login-token",
      path: "/loginCV/:uuid",
      component: LoginCV,
      meta: {
        requiresAuth: false,
        title: "Login CV",
        packLevel: 0,
        visualLevel: 0,
      },
    },
    {
      name: "login-tokenl",
      path: "/loginCVL/:uuid",
      component: LoginCVL,
      meta: {
        requiresAuth: false,
        title: "Login CV",
        packLevel: 0,
        visualLevel: 0,
      },
    },
    {
      name: "emailCV",
      path: "/emailCV",
      component: EmailCV,
      meta: {
        requiresAuth: true,
        title: "EmailCV",
        packLevel: 0,
        visualLevel: 0,
        autologout: true,
      },
    },
    {
      name: "emailCVL",
      path: "/emailCVL",
      component: EmailCVL,
      meta: {
        requiresAuth: true,
        title: "EmailCVL",
        packLevel: 0,
        visualLevel: 0,
        autologout: true,
      },
    },
    {
      name: "clientMailCV",
      path: "/clientMailCV/:annoPratica?/:numeroPratica?",
      component: ClientMailCV,
      meta: {
        requiresAuth: true,
        title: "Email CloudVillage",
        packLevel: 0,
        visualLevel: 0,
      },
    },
    {
      name: "loader",
      path: "/loader",
      component: Loader,
      meta: {
        title: "Settings",
        requiresAuth: false,
        packLevel: 0,
        visualLevel: 0,
      },
    },
    {
      name: "dashboard",
      path: "/dashboard",
      component: TheDashboard,
      meta: {
        title: "Dashboard",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "templator",
      path: "/templator/:id?",
      component: Templator,
      meta: {
        title: "Template editor",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "template-dashboard",
      path: "/templateDashboard",
      component: TemplateDash,
      meta: {
        title: "Template Dashboard",
        requiresAuth: true,
        packLevel: 10,
        visualLevel: 1,
      },
    },
    {
      name: "image-manager",
      path: "/imageManager",
      component: ImageManager,
      meta: {
        title: "Image Manager",
        requiresAuth: true,
        packLevel: 0,
        visualLevel: 1,
      },
    },

    {
      name: "settings-mail-cv",
      path: "/settings/mailCV",
      component: SettingsMailCV,
      meta: {
        title: "Template Dashboard",
        requiresAuth: true,
        packLevel: 0,
        visualLevel: 0,
      },
    },

    {
      name: "settings-mail-cvl",
      path: "/settings/mailCVL",
      component: SettingsMailCVL,
      meta: {
        title: "Template Dashboard",
        requiresAuth: true,
        packLevel: 0,
        visualLevel: 0,
      },
    },

    {
      name: "error404",
      path: "/:pathMatch(.*)",
      component: TheMissing404,
      meta: {
        packLevel: 0,
        visualLevel: 0,
      },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const guard = await store.dispatch("auth/isAuth"); // credential chek every time is reloaded the page
  if (to.meta.requiresAuth && !guard) {
    next("/login");
  } else {
    //! logout automatico se si accede con account di servizio e no si è dentro le route specifiche

    var packLevel = await store.dispatch("auth/loadPackLevel");

    // console.log(packLevel < 10 && to.meta.packLevel > 0)
    // console.log("🚀 ~ file: router.js:629 ~ router.beforeEach ~ to:", to)
    // console.log("🚀 ~ file: router.js:629 ~ router.beforeEach ~ packLevel:", packLevel)
    if (packLevel < 10 && to.meta.packLevel > 0) {
      await store.dispatch("auth/logout");
    }

    /**
     * Pack level 0 -> solo mail
     * Pack level 10 -> crm completo
     */

    //! attualmente disattivato, se si attiva ci sono pagine dedicate esclusivamente a piani di attivazione

    // if (packLevel >= to.meta.packLevel) {
    next();
    // } else {
    // 	next("/nonAutorizzato");
    // }
  }
});

router.afterEach((a, b, failure) => {
  if (isNavigationFailure(failure)) {
    console.log("failed navigation", failure);
    // if(a.fullPath === b.fullPath){
    //   window.location.reload()
    // }
  }
});

router.onError((error) => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
